import React from 'react'

import { Alert } from 'react-bootstrap'

export const Message = ({ title, type = "success", children }) => (
  <Alert bsStyle={type}>
    <h4>{ title }</h4>
    { children }
  </Alert>
)
